/* eslint-disable jsx-a11y/alt-text */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Switch, Route, Redirect } from 'react-router-dom';
import { withRouter } from 'react-router'
import { Container } from 'reactstrap';
import '../styles/base.scss';
import './full.scss';
import Loading from '../components/Loading';
import Breadcrumb from "./Breadcrumb/Breadcrumb";
import Sidebar from "./Sidebar/Sidebar";
import Header from "./Header/Header";
import Footer from "./Footer/Footer";
import { isAuth } from '../index'
import ModalMessage from '../components/modalMessage'
import { CLOSE_MODAL_MESSAGE, dispatchModalMessage } from "redux/actions/modalMessage";
import ModalConfirm from "components/modalConfirm/ModalConfirm";
import { checkDuplicateArr, getLocalStorage, setLocalStorage } from 'helper/utils'
import ToastNotification from "components/ToastNotification";

const setTempUrl = () => {
  setLocalStorage({ key: 'tempUrl', value: window.location.pathname })
  return <Redirect to='/login' />
}

class Full extends Component {
  render() {
    const { modalConfirm, permission, location } = this.props

    return isAuth && checkDuplicateArr(permission, location.pathname) ? (
      <React.Fragment>
        <div className='app'>
          <Header {...this.props} />
          <Sidebar {...this.props} />
          <section id='content'>
            <Breadcrumb {...this.props} />
            <Container fluid>
              <Loading />
              {this.props.children}
            </Container>
          </section>
        </div>
        <ModalMessage
          isShowModalMessage={this.props.modalMessage.isShowModalMessage}
          title={this.props.modalMessage.title}
          message={this.props.modalMessage.message}
          confirmCallback={() =>
            this.props.dispatch(
              dispatchModalMessage({ type: CLOSE_MODAL_MESSAGE }),
            )
          }
        />

        <ModalConfirm
          isOpen={modalConfirm.isOpen}
          message={modalConfirm.message}
          btnConfirm={modalConfirm.btnConfirm}
          btnCancel={modalConfirm.btnCancel}
          confirm={modalConfirm.confirm}
          isClose={modalConfirm.isClose}
          message2={modalConfirm.message2}
          type={modalConfirm.type}
        />
        <ToastNotification/>
      </React.Fragment>
    ) : isAuth ? (
      <Redirect to={permission[0]} />
    ) : (
      setTempUrl()
    )
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  modalMessage: state.modalMessage,
  modalConfirm: state.modalConfirm.modalConfirm
});

export default connect(mapStateToProps)(withRouter(Full))
